module.exports = __webpack_public_path__ + "img/gate-rail-vertical-shadow-left.43038f81.png";